<template>
<bernstein-layout>
      <Head title="Purchase Creation" />
    <div class="flex justify-center items-center bg-blue-100 min-h-screen">
        <div class="lg:w-2/5 md:w-1/2 w-2/3">
            <!-- test -->
            <form @submit.prevent="submit" class="mb-2">
                 <h1 class="text-2xl font-bold text-gray-900 p-2 mb-4 text-center"> Purchase Entry </h1>
                 <!-- Here is the order id  -->
                <div class="flex mb-1 py-2">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" for="orderId">OrderId</label>
				    <input class="w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none w-2/3" 
                        type="text" 
                        name="orderId"
                         
                        id="orderId" 
                        v-model="form.orderId"
                        placeholder="Order Id"
                        required />
                </div>
                 <!-- Manufacturer  -->
                 <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="manufacturer">Manufacturer</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="text" 
                        name="manufacturer" 
                        id="manufacturer" 
                        v-model="form.manufacturer"
                        placeholder="Manufacturer" 
                         required />
                </div>
                 <!-- Rechnungs nummer  -->
                 <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="billNo">Rechnungs Nr.</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="text" 
                        name="billNo" 
                        id="billNo" 
                        v-model="form.billNo"
                        placeholder="Rechnungs Nr."
                          required />
                </div>
                  <!-- anzahlung_betrag_usd -->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="anzahlung_betrag_usd">Anzahlung Betrag (USD)</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="anzahlung_betrag_usd" 
                        id="anzahlung_betrag_usd" 
                        v-model="form.anzahlung_betrag_usd"
                        placeholder="Anzahlung Betrag (USD) " /> 
                </div>
                 <!-- anzahlung kurs-->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="anzahlung_kurs">Anzahlung Kurs</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="anzahlung_kurs" 
                        id="anzahlung_kurs" 
                        v-model="form.anzahlung_kurs"
                        placeholder="Anzahlung Kurs " /> 
                </div>
                 <!-- anzahlung_rechnung  -->     
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="anzahlung_rechnung">Anzahlung Rechnung</label>
		<input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none  text-center
                            transition
                            ease-in-out
                            m-0" 
                        type="file"
                        @input ="form.anzahlung_rechnung=$event.target.files[0]" 
                        step="any"
                        name="anzahlung_rechnung" 
                        id="anzahlung_rechnung" 
                        placeholder="Anzahlung Rechnung " /> 
                     <!-- progress bar  -->
                 
                
                </div>
                <!-- anzahlung_datum  -->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="anzahlung_datum">Anzahlung Datum</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:bg-white  focus:outline-none" 
                        type="date" 
                        step="any"
                        name="anzahlung_datum" 
                        id="anzahlung_datum" 
                        v-model="form.anzahlung_datum"
                        placeholder="Anzahlung Datum " /> 
                </div>
                 <!-- anzahlung notiz  -->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="az_notiz">Anzahlung Notiz</label>
				    <textarea class=" w-2/3 block  
                                form-control
                                text-base 
                             bg-gray-100 
                                px-4 py-2 
                                bg-clip-padding
                                rounded-lg 
                                transition
                                ease-in-out
                                m-0
                                 focus:text-gray-900 
                                 focus:bg-white 
                                 focus:border-blue-100 
                                 focus:outline-none" 
                         name="az_notiz" 
                        id="az_notiz" 
                        rows="3"
                        v-model="form.az_notiz"
                        placeholder="Anzahlung Notiz " > 
                        </textarea> 
                </div>
                 <!-- here  is Rest zahlung  info  -->
                      <!-- rest_betrag_usd -->
                <div class="flex py-2 mb-1">
		        <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="rz_betrag_usd">RZ Betrag (USD)</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="rz_betrag_usd" 
                        id="rz_betrag_usd" 
                        v-model="form.rz_betrag_usd"
                        placeholder="RZ Betrag (USD) " /> 
                </div>
                 <!-- rz kurs-->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="rz_kurs">RZ Kurs</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="rz_kurs" 
                        id="rz_kurs" 
                        v-model="form.rz_kurs"
                        placeholder="RZ Kurs " /> 
                </div>
                 <!-- rz_rechnung  -->
     
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="rz_rechnung">RZ Rechnung</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none  text-center
                            transition
                            ease-in-out
                            m-0" 
                        type="file"
                        @input ="form.rz_rechnung=$event.target.files[0]" 
                        step="any"
                        name="rz_rechnung" 
                        id="rz_rechnung" 
                        placeholder="RZ Rechnung " /> 
                     <!-- progress bar  -->
                  
                
                </div>
                <!-- rz_datum  -->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="rz_datum">RZ Datum</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:bg-white  focus:outline-none" 
                        type="date" 
                        step="any"
                        name="rz_datum" 
                        id="rz_datum" 
                        v-model="form.rz_datum"
                        placeholder="rz Datum " /> 
                </div>
                 <!-- rz notiz  -->
                <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="az_notiz">RZ Notiz</label>
				    <textarea class=" w-2/3 block  
                                form-control
                                text-base 
                             bg-gray-100 
                                px-4 py-2 
                                bg-clip-padding
                                rounded-lg 
                                transition
                                ease-in-out
                                m-0
                                 focus:text-gray-900 
                                 focus:bg-white 
                                 focus:border-blue-100 
                                 focus:outline-none" 
                         name="rz_notiz" 
                        id="rz_notiz" 
                        rows="3"
                        v-model="form.rz_notiz"
                        placeholder="RZ Notiz " > 
                        </textarea> 
                </div>
                 <!-- Verrechnung   -->
                    <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="verrechnung">Verrechnung</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="verrechnung" 
                        id="verrechnung" 
                        v-model="form.verrechnung"
                        placeholder="Verrechnung" /> 
                </div>
                  <!-- offene Zahlung (USD)  -->
                    <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="oz_usd">Offene Zahlung (USD)</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        step="any"
                        name="oz_usd" 
                        id="oz_usd" 
                        v-model="form.oz_usd"
                        placeholder="Offene Zahlung (USD)" />  
                </div>
                <!-- // Kreditor  -->
                 <div class="flex mb-1 py-2">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                        for="kreditor">
                        Kreditor</label>
				    <input class="w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none w-2/3" 
                        type="text" 
                        name="kreditor"
                         
                        id="kreditor" 
                        v-model="form.kreditor"
                        placeholder="Kreditor"
                        />
                </div>
                    <!--kreditor_nummer  -->
                    <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="kreditor_nummer">Kreditornummer</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        name="kreditor_nummer" 
                        id="kreditor_nummer" 
                        v-model="form.kreditor_nummer"
                        placeholder="Kreditornummer" /> 
                </div>
                     <!--Anzahlung   euro-->
                    <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="az_euro">Anzahlung Euro</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        name="az_euro" 
                        id="az_euro" 
                        v-model="form.az_euro"
                        placeholder="Anzahlung in Euro" /> 
                </div>
                <!--Rest   euro-->
                    <div class="flex py-2 mb-1">
				    <label class="text-gray-900 font-semibold block my-3 text-lg  w-1/3" 
                    for="rz_euro">Restzahlung Euro</label>
				    <input class=" w-2/3 bg-gray-100 px-4 py-2 rounded-lg focus:outline-none" 
                        type="number" 
                        name="rz_euro" 
                        id="rz_euro" 
                        v-model="form.rz_euro"
                        placeholder="Restzahlung in Euro" /> 
                </div>
                <!-- Progress baar      -->
                   <progress v-if="form.progress" 
                        :value="form.progress.percentage" 
                        max="100">
                    {{ form.progress.percentage }}%
                    </progress>
                     
                <!-- Speichern  -->
                 	<button type="submit" 
                     class="w-full mt-6 bg-indigo-600 rounded-lg px-4 py-2 text-lg text-white 
                        tracking-wide font-semibold font-sans mb-4">Speichern</button>
				
            </form>
        </div>      
    </div>
</bernstein-layout>
</template>
<script>
import { reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head, Link } from '@inertiajs/inertia-vue3';
import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'

export default {
   setup () {
    const form = reactive({
      orderId: null,
      manufacturer: null,
      billNo: null,
      anzahlung_betrag_usd: null,
      anzahlung_kurs:null,
      anzahlung_rechnung:null,
      anzahlung_datum:null,
      az_notiz:null,
      rz_betrag_usd: null,
      rz_kurs:null,
      rz_rechnung:null,
      rz_datum:null,
      rz_notiz:null,
      verrechnung:null,
      oz_usd: null ,
      kreditor:null,
      kreditor_nummer:null,
      az_euro:null,
      rz_euro:null,



    })

    function submit() {
      Inertia.post('/purchases', form)
    }

    return { form, submit }
  },
    components:{
        Head,
        Link,
        BernsteinLayout
    }
}
</script>